import { Component } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import styles from './SpecSetting.css'
import {
  getSpecItemExceedLength
} from '../../../../../Common/ProposalForm/Shared/util'
import List from './List'
import { FieldArray } from 'redux-form'
import { ListingFieldConfig } from '../../../../../Common/ProposalForm/Shared/FieldConfig'
import InputPicker from '../../../../../../Common/InputPicker'
import Tip from '../../../../../Common/Tip'
import { Icon } from '@vzmi/shp_shared_compo'
import { When } from '../../../../../../Common/Form'
import { Field } from '../../../../../../Common/forms'

// reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

class SpecSetting extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeEditor: props.disableForm || false
    }
  }

  componentDidMount () {
    const { defaultFormData = {} } = this.props
    const { specItems = [] } = defaultFormData
    const formData = {
      ...defaultFormData,
      specItems: _.map(specItems, (item, idx) => {
        const { value } = item
        return ({ ...item, id: idx + 1, oldValue: value })
      })
    }
    this.props.initialize(formData)
    // validate fields on mount
    this.props.touch('productName')
    _.map(specItems, (item, idx) => {
      this.props.touch(`specItems[${idx}].value`)
    })
  }

  componentDidUpdate (prevProps) {
    const nextDisableForm = this.props.disableForm
    if (nextDisableForm && !_.isEqual(nextDisableForm, prevProps.disableForm)) {
      this.triggerEditor(true)
    }
  }

  componentWillUnmount () {
    this.props.destroy()
  }

  triggerEditor = (active) => {
    this.setState({
      activeEditor: _.isUndefined(active) ? !this.state.activeEditor : active
    })
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }
    const items = reorder(
      this.props.specItems,
      result.source.index,
      result.destination.index
    )
    if (result.source.index !== result.destination.index) {
      this.props.change('specItems', items)
    }
  }

  render () {
    const {
      handleSubmit,
      productName = '',
      currentProductNameLengthMax,
      lengthMaxInModal,
      productNameValidation,
      change,
      disableForm,
      lengthUsedByFirstLayer,
      level
    } = this.props
    const { activeEditor } = this.state
    const currentNameLength = productName ? productName.length : 0
    const specItemsExceedLength = getSpecItemExceedLength(currentProductNameLengthMax, level, lengthUsedByFirstLayer, currentNameLength)

    return (
      <form
        onSubmit={handleSubmit}
        data-role='spec-setting-form'
      >
        <div
          key='editor'
          className={styles.editorSection}
        >
          <div
            key='header'
            className={styles.header}
          >
            <ul>
              <li>
                <Tip
                  type='label'
                  className={styles.tip}
                >
                  <When
                    value={specItemsExceedLength <= 0}
                    isTrue
                  >
                    <Icon
                      name='ec-warning-fill'
                      size={18}
                      align='sub'
                      className={styles.info}
                    />
                  </When>
                  {`商品名稱字數需在${currentProductNameLengthMax}字以內，範例：”定番條紋上衣-灰-S“ 需≤${currentProductNameLengthMax}個字`}
                </Tip>
              </li>
              <li>
                <Tip
                  type='label'
                  className={styles.tip}
                >
                  商品名稱 = 名稱-第1層項目-第2層項目
                  <InputPicker
                    data-role='editor-button'
                    className={styles.editButton}
                    active={activeEditor}
                    disabled={disableForm}
                    onClick={() => this.triggerEditor()}
                    value={'修改名稱'}
                  />
                </Tip>
              </li>
            </ul>
          </div>
          {activeEditor && (
            <div key='productName'>
              <Tip
                key='tip'
                type='subTitle'
              >
                提醒：賣場網址會隨著賣場名稱的修改而變動
              </Tip>
              <Field
                key='productNameField'
                {...ListingFieldConfig.getField('product.name')}
                name='productName'
                placeholder={`最多輸入${lengthMaxInModal}個字`}
                className={cx(styles.productName, styles.modalInputField)}
                countLimit={lengthMaxInModal}
                inlineCount
                validate={productNameValidation}
              />
            </div>
          )}
        </div>
        <div key='specItems'>
          <FieldArray
            key={specItemsExceedLength}
            name='specItems'
            onDragEnd={this.onDragEnd}
            triggerFieldChange={change}
            exceedLength={specItemsExceedLength}
            component={List}
          />
        </div>
      </form>
    )
  }
}

export default SpecSetting
